module.exports = __webpack_public_path__ + "img/oaks-nest-kitchen-1.653f2f45.jpeg";